export default "__VITE_ASSET__Y1jRua2r__"